module.exports = __webpack_public_path__ + "57ca11499ced95166d3249e591a007ef.png";